export default __webpack_public_path__ + "media/images/portfolio/gallery-09-1200x7_original-05267bc357c29c5a80cbffad03e52454.jpg";